export const API_KEY = "362dd96401a84b14a9c8ef78e2293dea"

export const requestOptions = {
    method: 'GET',
};